import { render, staticRenderFns } from "./ProductPackages.vue?vue&type=template&id=0914276a&"
import script from "./ProductPackages.vue?vue&type=script&lang=js&"
export * from "./ProductPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports